import type { FieldDescriptor } from "./service";

/**
 * Draft state for one Field Mappings row. Kept in its own module (no React/styled imports) so the
 * `descriptor`-crash invariant below is purely unit-testable.
 */
export interface MappingRowState {
  targetFieldName: string;
  strategy: "append" | "overwrite";
  descriptor?: FieldDescriptor;
  valueDelimiter?: string;
}

/**
 * A rendered mapping row is NEVER undefined: a source column with no draft state yet resolves to a
 * fresh unmapped row. This is the invariant that guarantees `FieldPicker` can't read `.descriptor`
 * off `undefined` — the crash that occurred when one workflow's draft rows (keyed by its own column
 * names) were briefly looked up against another workflow's columns.
 */
export function resolveRow(
  state: Record<string, MappingRowState>,
  col: string
): MappingRowState {
  return state[col] ?? { targetFieldName: "", strategy: "append" };
}
